// Firebase initialization with authoritative applet configuration
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import appletConfig from "../firebase-applet-config.json";

// Authoritative config from provisioned firebase-applet-config.json with env fallbacks
const cfg = {
  apiKey: appletConfig.apiKey || process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: appletConfig.authDomain || process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: appletConfig.projectId || process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: appletConfig.storageBucket || process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: appletConfig.messagingSenderId || process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: appletConfig.appId || process.env.REACT_APP_FIREBASE_APP_ID,
};

export const HAS_FIREBASE = Boolean(cfg.apiKey && cfg.projectId && cfg.appId);
const envAdmin = (process.env.REACT_APP_ADMIN_EMAIL || "").toLowerCase().trim();
const parsedAdmins = envAdmin.split(",").map((e) => e.trim().toLowerCase()).filter(Boolean);

export const ADMIN_EMAILS = [
  ...new Set([
    "scorpion004ss@gmail.com",
    "shuvo100.ss@gmail.com",
    ...parsedAdmins,
  ])
];
export const ADMIN_EMAIL = ADMIN_EMAILS[0] || "scorpion004ss@gmail.com";

let app = null;
let auth = null;
let db = null;
let storage = null;

const firestoreDatabaseId = appletConfig.firestoreDatabaseId || process.env.REACT_APP_FIREBASE_DATABASE_ID;

if (HAS_FIREBASE) {
  app = getApps()[0] || initializeApp(cfg);
  auth = getAuth(app);
  try {
    let settings = {};
    if (typeof window !== "undefined" && typeof indexedDB !== "undefined") {
      try {
        settings.localCache = persistentLocalCache({ tabManager: persistentMultipleTabManager() });
      } catch (cacheErr) {
        console.warn("Firestore persistent cache fallback:", cacheErr);
      }
    }
    db = firestoreDatabaseId
      ? initializeFirestore(app, settings, firestoreDatabaseId)
      : initializeFirestore(app, settings);
  } catch (e) {
    db = firestoreDatabaseId ? getFirestore(app, firestoreDatabaseId) : getFirestore(app);
  }
  storage = getStorage(app);
}

export const FIRESTORE_DATABASE_ID = firestoreDatabaseId;

export const OAUTH_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  appletConfig.oAuthClientId ||
  "868045259436-pv37vnlmh3vq2l0jq7p3obp976v2v4m5.apps.googleusercontent.com";

export const OperationType = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  LIST: "list",
  GET: "get",
  WRITE: "write",
};

export function handleFirestoreError(error, operationType, path) {
  const errInfo = {
    error: error instanceof Error ? error.message : String(error),
    authInfo: {
      userId: auth?.currentUser?.uid || null,
      email: auth?.currentUser?.email || null,
      emailVerified: auth?.currentUser?.emailVerified || null,
      isAnonymous: auth?.currentUser?.isAnonymous || null,
      tenantId: auth?.currentUser?.tenantId || null,
      providerInfo: auth?.currentUser?.providerData?.map((provider) => ({
        providerId: provider.providerId,
        email: provider.email,
      })) || [],
    },
    operationType,
    path: path || null,
  };
  console.error("Firestore Error: ", JSON.stringify(errInfo));
  throw new Error(JSON.stringify(errInfo));
}

export { app, auth, db, storage };
